export const SET_LOCATION = 'SET_LOCATION';
export const SET_LOCATIONS = 'SET_LOCATIONS';
export const SET_LOCATIONS_DRAFTS = 'SET_LOCATIONS_DRAFTS';
export const SET_LOCATIONSMODAL = 'SET_LOCATIONSMODAL';
export const SET_LOCATIONS_QUERY_PARAMS = 'SET_LOCATIONS_QUERY_PARAMS';
export const SET_LOCATIONS_SET_IS_FETCHING = 'SET_LOCATIONS_SET_IS_FETCHING';
